
(function restUrlBuilderModuleDefinition() {

    'use strict';

    angular.module('RESTUrlBuilder', []);

})();